module.exports = __webpack_public_path__ + "static/media/kredyt_9.b58524a2.png";